<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <h1 class="title">About</h1>
        <div class="content">
          <p>
            Avails.Africa provides a centralised gateway platform for buyers
            (Free-to-Air Broadcasters) and content sellers to efficiently and
            cost effectively license content for territories in Africa.
            Free-to-Air Broadcasters group their budgets together, the platform
            then acts as a Group Buying cooperative to secure International
            content.
          </p>
          <p>
            Broadcasters share the fees for each title while still maximising Ad
            revenue on a local level. The content seller shares in the
            additional licensing revenue from the content.
          </p>
          <p>
            Scheduling and content autonomy remain in the hands of the
            Broadcaster.
          </p>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
export default {
  name: 'Home',
  components: {
    CardComponent
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>
